import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../environments/environment';
import { IAppConfig } from '../shared/models/app-config.model';

@Injectable()
export class AppConfigService {

  static settings: IAppConfig;

  constructor(private http: Http) {}

  load() {
      let jsonFile = 'assets/config/config.json';
      if (!environment.production) {
        jsonFile = 'assets/config/config-dev.json';
      }

      return new Promise<void>((resolve, reject) => {
        this.http.get(jsonFile).toPromise().then((response: Response) => {
            AppConfigService.settings = <IAppConfig> response.json();
            if(AppConfigService.settings.toastRMessagesDismissTime === undefined) {
              // Valeur défaut
              AppConfigService.settings.toastRMessagesDismissTime = 10000;
            }

            if(AppConfigService.settings.observationsMaxLength === undefined) {
              // Valeur défaut
              AppConfigService.settings.observationsMaxLength = 1000;
            }

            if(AppConfigService.settings.showBoutonSupprimerBrouillon === undefined) {
              // Bouton suppression du brouillon masqué par défaut
              AppConfigService.settings.showBoutonSupprimerBrouillon = false;
            }

            resolve();
        }).catch((response: any) => {
            reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/app-config.service.ts